import React from "react";
import { Nav } from "react-bootstrap";
import { RIGHT_SIDEBAR_TOGGLE_CLASS } from "@cleanup/widgets/RightSideBar/RightSideBar";

interface HeaderIconButtonProps {
  title: string;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  children: React.ReactNode;
  badge?: number;
  // The panel this button opens is currently showing.
  active?: boolean;
}

const HeaderIconButton: React.FC<HeaderIconButtonProps> = ({
  title,
  onClick,
  children,
  badge,
  active = false,
}) => {
  return (
    <Nav.Item
      title={title}
      onClick={onClick}
      role="button"
      aria-pressed={active}
      style={{
        padding: "0 8px",
        fontSize: 20,
        height: 49,
      }}
      className={`d-flex justify-content-center align-items-center ${RIGHT_SIDEBAR_TOGGLE_CLASS}${
        active ? " active" : ""
      }`}
    >
      {badge !== undefined && badge > 0 && (
        <span className="position-relative">
          <span
            className="position-absolute translate-middle badge rounded-pill bg-danger"
            style={{ fontSize: 10, top: -12, left: 20 }}
          >
            {badge}
          </span>
        </span>
      )}
      {children}
    </Nav.Item>
  );
};

export default HeaderIconButton;
